(function () {
    'use strict';
    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     *
     */

    angular
        .module('ihh-common-web')
        .controller('ProfileCtrl', ProfileCtrl);

    ProfileCtrl.$inject = ['$scope', 'ProfileService', '$interval', 'ProfileConstants', 'ObserverService', 'AUTH_EVENTS'];

    function ProfileCtrl ($scope, ProfileService, $interval, ProfileConstants, ObserverService, AUTH_EVENTS) {
        var vm = this;
        var staffId;
        var clinicProfessional;
        var lastRetrieved = null;
        var alertList = [];
        var interval;
        vm.alertCount = 0;

        activate();

        function activate () {
            getAlertCount(true);
            setupAlertCountInterval();
            setupCleanup();
            registerObserverCallbacks();
        }

        function getAlertCount (overrideTimer) {
            staffId = ProfileService.getStaffId($scope.getSelf(), $scope.user);

            if (staffId === null && $scope.user.clinic) {
                clinicProfessional = $scope.getClinicProfessional($scope.user.clinic);
                if (clinicProfessional) {
                    staffId = clinicProfessional.id;
                }
            }

            if (lastRetrieved === null) {
                overrideTimer = true; // always ensure we make at least one call
            }

            if (staffId !== null) {
                ProfileService.getMyAlerts(staffId, overrideTimer, $scope.user).then(function (result) {
                    alertList = result.alertList;
                    lastRetrieved = result.lastRetrieved;
                    vm.alertCount = alertList.length;
                    ObserverService.notifyObservers(ProfileConstants.observers.alertsRetrieved, alertList);
                });
            }
        }

        function setupAlertCountInterval() {
            if (angular.isDefined(interval)) {
                return;
            }
            else {
                interval = $interval(function () {
                    getAlertCount(false);
                }, ProfileConstants.pollingFrequency.milliseconds);
            }
        }

        function stopAlertCountQuery () {
            if (angular.isDefined(interval)) {
                $interval.cancel(interval);
                interval = undefined;
            }
        }

        function setupCleanup() {
            $scope.$on('$destroy', function () {
                stopAlertCountQuery();
            });
        }

        function forceAlertCountRequest () {
            stopAlertCountQuery();
            activate();
        }

        function registerObserverCallbacks () {
            ObserverService.registerObserverCallback(ProfileConstants.observers.refresh, forceAlertCountRequest);
            ObserverService.registerObserverCallback(AUTH_EVENTS.logout, stopAlertCountQuery);
        }
    }
})();
